export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8770.7304b6fb.jpg";